import { useTranslation } from "react-i18next";
import { useState } from "react";
import { buildRiskObject, isOnlyNumber } from "../../pages/utils";
import { Consts } from "../../pages/consts";
import GenoAndPhenoSelection from "./GenoAndPhenoSelection";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faXmark} from "@fortawesome/free-solid-svg-icons";

const PhenoGenotype = ({ gene, allGenes, onSetGene }) => {
  const { t } = useTranslation();
  const [phenotype, setPhenotype] = useState("");
  const [allele1, setAllele1] = useState(t(Consts.NOT_SPECIFIED));
  const [allele2, setAllele2] = useState(t(Consts.NOT_SPECIFIED));

  const handleSetGeneDetails = () => {
    const filteredGenes = allGenes?.filter((g) => g.geneName === gene?.geneName);

    let genotype = [
      (allele1 && (isOnlyNumber(allele1) || allele1 === "4A/B" || allele1 === "1173C>T" || allele1 === "XN")
          ? "*"
          : ""
      ) + (allele1 || t(Consts.NOT_SPECIFIED)),
      (allele2 && (isOnlyNumber(allele2) || allele2 === "4A/B" || allele1 === "1173C>T" || allele1 === "XN")
        ? "*"
        : ""
      ) + (allele2 || t(Consts.NOT_SPECIFIED)),
    ]?.join("/");

    genotype = formatGenotype(genotype);

    if (filteredGenes?.length > 0) {
      const riskObj = buildRiskObject(phenotype, genotype, filteredGenes[0]);

      onSetGene({
        ...gene,
        phenotype,
        genotype,
        risks: riskObj.risks,
        genoRisks: riskObj.genoRisks,
        phenoRisks: riskObj.phenoRisks,
      });
    }
  };

  const formatGenotype = (genotype) => {
    genotype = genotype?.toLowerCase();
    const isNotSpecified = genotype === `${t(Consts.NOT_SPECIFIED)?.toLowerCase()}
    /${t(Consts.NOT_SPECIFIED)?.toLowerCase()}`;

    return isNotSpecified
      ? t(Consts.NOT_SPECIFIED)?.toLowerCase()
      : genotype?.replaceAll('4a/b', '4A/B')?.replaceAll('c>t', 'C>T')?.replaceAll('xn', 'XN');
  };

  return (
    <div className="w3-modal" style={{ display: Consts.BLOCK }}>
      <div className="w3-modal-content w3-card-4 w3-animate-zoom form-panel disease-tree dialog-narrow">
        <header className="feedback-modal-header">
          <h2 className="w3-margin-left">{t("gene")} {gene?.geneName}</h2>
          <FontAwesomeIcon
            icon={faXmark}
            className="modal-close w3-margin-right w3-margin-top"
            onClick={() => onSetGene(null)}
          />
        </header>
        <div className="modal-pgx w3-margin-left">{t("select_pheno_geno")}</div>
        <div className="w3-container w3-margin-top">
          <GenoAndPhenoSelection
            setPhenotype={(value) => setPhenotype(value)}
            setAllele1={setAllele1}
            setAllele2={setAllele2}
          />
        </div>
        <footer className="w3-container w3-padding-small w3-margin-top">
          <p className="w3-right">
            <button
              className="w3-btn w3-round-xlarge w3-theme-d5"
              onClick={handleSetGeneDetails}
            >
              {t("submit")}
            </button>
          </p>
        </footer>
      </div>
    </div>
  );
};

export default PhenoGenotype;
